<configuration-option-product-groups-purchase-flow
  [formValues]="configFormValues$ | async"
  (onSubmit)="onSubmit($event)"
></configuration-option-product-groups-purchase-flow>
